import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import ReactPixel from 'react-facebook-pixel';
const PIXEL_ID = '1957655631651111';
ReactPixel.init(PIXEL_ID);
ReactPixel.pageView();
render(<App data-id="element-446" data-mp="219eiwkp3totg" />, document.getElementById('root'));